module.exports = __webpack_public_path__ + "static/media/canvas_arrow.9d3b845f.svg";